import React, { useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Card, CardContent } from '@/Components/ui/card';
import { Heading, Text } from '@/Components/ui/typography';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

function BackendRedirectHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extract token from the current URL
    const pathParts = location.pathname.split('/');
    const token = pathParts[pathParts.length - 1];
    
    // Check if this looks like a valid token
    if (token && token.length > 10 && !token.includes('reset-password-employer')) {
      // Redirect to our frontend reset password page
      navigate(`/hirewithus/reset-password/${token}`, { replace: true });
    } else {
      // If no valid token, redirect to forgot password
      navigate('/hirewithus/forgot-password', { replace: true });
    }
  }, [navigate, location]);

  return (
    <div className="min-h-screen w-full bg-background text-foreground flex flex-col justify-center items-center relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, hsl(var(--foreground)) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Logo Section - Top Left */}
      <div className="absolute top-6 left-6 md:top-8 md:left-8 z-10">
        <Link 
          to="/hirewithus"
          className="transition-opacity hover:opacity-80"
        >
          <img
            src="/Newzenalphablue.png"
            alt="SearchJob.ai Logo"
            className="h-8 md:h-10 w-auto object-contain drop-shadow-sm"
          />
        </Link>
      </div>
      
      <div className="flex justify-center items-center gap-12 max-w-7xl w-full flex-wrap px-6 py-12 md:flex-nowrap relative z-10">
        <Card className={cn(
          "flex flex-col w-full max-w-[400px] p-8 md:p-10",
          "bg-card border border-border/50",
          "shadow-xl shadow-primary/5",
          "transition-all duration-300",
          "hover:shadow-2xl hover:shadow-primary/10"
        )}>
          <CardContent className="w-full p-0 space-y-6 text-center">
            <div className="flex justify-center mb-4">
              <Loader2 className="h-12 w-12 text-primary animate-spin" />
            </div>
            <Heading level="h3" className="text-2xl font-semibold mb-2">
              Redirecting...
            </Heading>
            <Text size="base" variant="muted" className="text-muted-foreground leading-relaxed">
              Please wait while we redirect you to the password reset page.
            </Text>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default BackendRedirectHandler;
